import { render } from "./InviteFriends.vue?vue&type=template&id=2705a780"
import script from "./InviteFriends.vue?vue&type=script&lang=ts"
export * from "./InviteFriends.vue?vue&type=script&lang=ts"
script.render = render

export default script